import { IsOptional, IsInt } from 'class-validator';
import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  JoinColumn,
  ManyToOne,
  DeleteDateColumn,
} from 'typeorm';
import { Paciente } from './Paciente';
import { Usuario } from './Usuario';
import { Exame } from './Exame';
import { Gestacao } from './Gestacao';
import { Consulta } from './Consulta';

@Entity({ name: 'resultados_de_exames' })
export class ResultadoDeExame {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsOptional()
  exame_id: number | null;

  @Column()
  @IsOptional()
  gestacao_id?: number | null;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsOptional()
  consulta_id?: number | null;

  @Column()
  @IsOptional()
  nome_exame?: string | null;

  @Column()
  @IsOptional()
  data_exame?: Date | null;

  @Column()
  @IsOptional()
  status?: string | null;

  @Column()
  @IsOptional()
  resultado?: string | null;

  @Column()
  @IsOptional()
  observacoes?: string | null;

  @Column()
  @IsOptional()
  justificativa?: string | null;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  @IsOptional()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  @DeleteDateColumn({ name: 'deleted' })
  deleted?: Date | null;

  @Column()
  @IsOptional()
  deleted_by?: number | null;

  // RELATIONS
  @ManyToOne(() => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @ManyToOne(() => Gestacao)
  @JoinColumn({ name: 'gestacao_id' })
  gestacao?: Gestacao;

  @ManyToOne(() => Exame, { eager: true })
  @JoinColumn({ name: 'exame_id' })
  exame?: Exame;

  @ManyToOne(() => Consulta)
  @JoinColumn({ name: 'consulta_id' })
  consulta?: Consulta;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'updated_by' })
  usuario_updated_by?: Usuario;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'deleted_by' })
  usuario_deleted_by?: Usuario;
}
